<app-legal-layout
  title="Bewertungs-Richtlinien"
  eyebrow="Transparenz nach § 5b UWG"
  lastUpdated="14.05.2026"
>
  <p>
    Wie Bewertungen auf Craftly entstehen, gemittelt und veröffentlicht werden
    — vollständig und transparent.
  </p>

  <h2 id="wer-kann-bewerten">Wer kann bewerten?</h2>
  <p>
    Nur Kunden und Handwerker, die einen Auftrag erfolgreich über Craftly
    abgewickelt haben. Es gibt keinen anderen Weg, eine Bewertung abzugeben.
    Jede Bewertung ist mit einer abgeschlossenen Buchung verknüpft, die über
    unsere treuhändische Stripe-Connect-Zahlung gelaufen ist — Fake-Bewertungen
    sind technisch nicht möglich.
  </p>

  <h2 id="wie-wird-bewertet">Wie wird bewertet?</h2>
  <p>
    Nach Auftragsabschluss bewerten sich Kunde und Handwerker gegenseitig in
    drei Kategorien à 1–5 Sternen (in 0,5er-Schritten). Die Bewertungen sind
    „double-blind": beide Seiten geben unabhängig voneinander ab und sehen die
    Bewertung der Gegenseite erst, wenn beide bewertet haben — spätestens nach
    14 Tagen. So sind Vergeltungs-Bewertungen ausgeschlossen.
  </p>

  <h2 id="anonymitaet">Anonymität</h2>
  <p>
    Sterne-Bewertungen werden öffentlich nur als <strong>aggregierter
    Durchschnitt</strong> angezeigt — niemals Einzelbewertungen, Zitate oder
    Namen. Damit Rückschlüsse auf einzelne Aufträge unmöglich sind, werden
    Bewertungen erst ab <strong>mindestens 3 Bewertungen</strong> öffentlich
    angezeigt. Bis dahin erscheint der Hinweis „Noch nicht genug Bewertungen".
    Auch dem Bewerteten gegenüber bleibt jede einzelne Bewertung anonym.
  </p>

  <h2 id="freitext">Freitext-Nachrichten</h2>
  <p>
    Beim Bewerten kannst du uns optional einen vertraulichen Freitext
    hinterlassen. Diese Nachrichten sind <strong>ausschließlich für das
    Craftly-Team</strong> einsehbar und werden niemals an den Bewerteten
    weitergegeben. Sie helfen uns, Qualität und Sicherheit auf der Plattform
    aktiv zu sichern.
  </p>

  <h2 id="vorab-pruefung">Werden Bewertungen vorab geprüft?</h2>
  <p>
    Nein. Bewertungen werden bei Vorliegen ausreichender Datenmenge automatisch
    anonymisiert veröffentlicht. Unser Team prüft Bewertungen nur nachträglich,
    wenn ein Verdacht auf Verstoß gegen diese Richtlinien gemeldet wird
    (Notice &amp; Action, DSA Art. 16).
  </p>

  <h2 id="incentives">Werden Bewertungen incentiviert?</h2>
  <p>
    Nein. Wir bieten keine Vergütung, Rabatte oder andere Vorteile für das
    Abgeben einer Bewertung. Andernfalls läge ein Verstoß gegen § 5b UWG vor.
  </p>

  <h2 id="entfernung">Wann werden Bewertungen entfernt?</h2>
  <p>Wir entfernen Bewertungen, die</p>
  <ul>
    <li>gegen die AGB verstoßen (z. B. beleidigend, diskriminierend),</li>
    <li>offensichtlich falsche Tatsachen behaupten,</li>
    <li>oder nicht das Auftragsverhältnis betreffen.</li>
  </ul>
  <p>
    Bei jeder Entfernung erhalten Bewerter und Bewerteter eine Information mit
    Begründung (DSA Art. 17). Gegen eine Moderationsentscheidung kann innerhalb
    von 6 Monaten Beschwerde eingelegt werden (DSA Art. 20).
  </p>

  <h2 id="korrektur">Kann ich meine Bewertung später ändern?</h2>
  <p>
    Innerhalb von 24 Stunden nach Abgabe kannst du deine Bewertung ändern.
    Danach ist sie aus Authentizitäts-Gründen nicht mehr editierbar — bei
    konkreten Fehlern wende dich bitte ans Craftly-Team über
    <a routerLink="/melden">/melden</a>.
  </p>

  <h2 id="account-loeschung">Was passiert bei Account-Löschung?</h2>
  <p>
    Bei Löschung deines Accounts werden deine Bewertungen anonymisiert — wir
    löschen die Verknüpfung zu deinem User, behalten aber die Bewertung selbst,
    damit der Durchschnitt anderer nicht verfälscht wird (DSGVO-konformer
    Trade-off, gemäß Art. 17 DSGVO begründbar als überwiegendes Interesse der
    Empfänger).
  </p>
</app-legal-layout>
